import Vue from 'vue'
import SvgIcon from '@/components/SvgIcon'// svg组件

// 全局注册svg-icon
//使用时<svg-icon icon-class="password" />
Vue.component('svg-icon', SvgIcon)

const req = require.context('./svg', false, /\.svg$/);

const requireAll = requireContext => requireContext.keys().map(requireContext);

requireAll(req)
